module.exports = __webpack_public_path__ + "static/assetsFallback@2x-45e31117f51ec1218504d083c4ff3137.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/assetsFallback@2x.png
// module id = 2594
// module chunks = 168707334958949